/**
 * Enum com as permissões existentes no sistema
 */

export enum BoletaDeIntermediacaoPermissao {
    LISTAR = "Listar Boleta de Intermediação",
    VISUALIZAR = "Visualizar Boleta de Intermediação",
    CADASTRAR = "Cadastrar Boleta de Intermediação",
    ALTERAR = "Alterar Boleta de Intermediação",
    EXCLUIR = "Excluir Boleta de Intermediação",
    EXPORTAR = "Exportar Boleta de Intermediação",
    RESERVAR = "Reservar Boleta de Intermediação",
    PREENCHER_MESA = "Preencher Mesa",
    LOG_EMAILS = "Log de Emails",
}

// TODO: FULFILL THIS ENUM WITH ALL PERMISSIONS
